/**
 * Method to get the style of the section container
 * of about us section.
 * @returns {{height: string}} — CSS style.
 */
export const getAboutUsSectionContainerStyle = () => {
	return {
		height: "var(--about-us-height)",
	};
};
